import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchNotifications = createAsyncThunk(
  "global/fetchNotifications",
  async (_, thunkAPI) => {
    try {
      // Replace with your actual API call, e.g.:
      // const data = await NotificationApi.getAll();
      // return data;

      // Placeholder — returns empty list until you wire up the real API
      return { notifications: [], unreadCount: 0 };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to fetch notifications");
    }
  }
);

// Initial State
const initialState = {
  notifications: [],
  unreadCount: 0,
  notificationsLoading: false,
  appAlert: null,

  featureFlags: {
    enableNewDashboard: false,
    enableChatV2: false,
  },
};

// Slice
const globalSlice = createSlice({
  name: "global",
  initialState,

  reducers: {
    setAppAlert(state, action) {
      // Payload: { type: "info" | "warning" | "error", message: "..." }
      state.appAlert = action.payload;
    },

    // Dismiss the app-level alert banner 
    clearAppAlert(state) {
      state.appAlert = null;
    },

    markAllNotificationsRead(state) {
      state.unreadCount = 0;
      state.notifications = state.notifications.map((n) => ({
        ...n,
        read: true,
      }));
    },

    setFeatureFlags(state, action) {
      state.featureFlags = { ...state.featureFlags, ...action.payload };
    },
  },

  // Handle async thunk lifecycle (pending / fulfilled / rejected)
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.notificationsLoading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.notificationsLoading = false;
        state.notifications = action.payload.notifications;
        state.unreadCount = action.payload.unreadCount;
      })
      .addCase(fetchNotifications.rejected, (state) => {
        state.notificationsLoading = false;
      });
  },
});

export const {
  setAppAlert,
  clearAppAlert,
  markAllNotificationsRead,
  setFeatureFlags,
} = globalSlice.actions;


export const selectNotifications = (state) => state.global.notifications;
export const selectUnreadCount = (state) => state.global.unreadCount;
export const selectAppAlert = (state) => state.global.appAlert;
export const selectFeatureFlags = (state) => state.global.featureFlags;

export default globalSlice.reducer;
